import { render } from "./NewSymptomReportView.vue?vue&type=template&id=9e66186e&scoped=true"
import script from "./NewSymptomReportView.vue?vue&type=script&lang=js"
export * from "./NewSymptomReportView.vue?vue&type=script&lang=js"

import "./NewSymptomReportView.vue?vue&type=style&index=0&id=9e66186e&lang=scss&scoped=true"
import "./NewSymptomReportView.vue?vue&type=style&index=1&id=9e66186e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e66186e"]])

export default __exports__